import React,{useState} from "react";
import { useFormik, useFormikContext } from "formik"
import * as Yup from "yup"
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export const RegisterAdmin=()=>{
    const navigate=useNavigate()
    const baseUrl=process.env.REACT_APP_SECOND_BACKEND_URL;
    const [profileView,setProfileView]=useState(null);
    const [errorMessage,setErrorMessage]=useState("");

    const formik=useFormik({
        initialValues:{
            username: "",
            email: "",
            password: "",
            confirm_password: "",           
            name: "",
            profile_picture: null, // Initialize profile picture state   
        },
        validationSchema:Yup.object().shape({
        username:Yup.string().required("Username is required").typeError("Username should be a string"),
        name: Yup.string().required("Name is required").typeError("Name should be a string"),    
      email: Yup.string().email("Invalid email format").required("Email is Required"),
      password: Yup.string()
        .min(10, "Password should have a minimum of 10 characters")
        .required("Password is required")
        .max(20, "Passwords should have a maximum value of 20 characters")
        .matches(/[A-Z]/, "Password should include at least one capital letter")
        .matches(/[a-z]/, "Password should include at least one small letter")
        .matches(/[0-9]/, "Password must include at least one number")
        .matches(/[@$!%*?&]/, "Password must include at least one special character"),
      confirm_password: Yup.string().oneOf([Yup.ref("password")], "Passwords do not match"),     
      profile_picture: Yup.mixed().nullable(), // Allow profile picture to be nullable            
        }),
        onSubmit:async(values,{setSubmitting})=>{
            try{
                const payLoad={...values,role:"admin"}                
             if(values.profile_picture){
                 const reader=new FileReader()
                reader.onloadend=async()=>{
                    payLoad.profile_picture=reader.result
                    await handleRegisterUser(payLoad)
                }
             reader.readAsDataURL(payLoad.profile_picture)
             }
             else{
                await handleRegisterUser(values)
             }
            }
            catch(error){

            console.error(`An error occurred registering`,error)
            }
            finally{
                setSubmitting(false)
                setErrorMessage("") 
            }
        }
    })

    const handleRegisterUser=async(values)=>{
        try {
            const response = await fetch(`${baseUrl}/register`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(values),
            });
        
            // Check if the response is not OK
            if (!response.ok) {
              const errorData = await response.json(); // Parse the JSON error response
              setErrorMessage(errorData.Error || errorData?.Message || "Registration failed. Please try again.");
              return; // Exit the function early
            }
        
            const data = await response.json(); // Parse the successful response
            if (data.token) {
              localStorage.setItem("Virtual_business_token", data.token);
              const decodedToken = jwtDecode(data.token);
              const role = decodedToken.sub.role;
              alert(`You are a ${role}. You have logged in successfully.`);
              navigate("/loginUser");
            } else {
              setErrorMessage(data.error || "An unknown error occurred.");
            }
          } catch (error) {
            console.error(`Error registering user: ${error}`);
            setErrorMessage("Registration failed. Please try again.");
          }
    }

    const handleFileChange=(event)=>{
        const file = event.currentTarget.files[0];
        formik.setFieldValue("profile_picture", file);
    
        // Preview the image
        const reader = new FileReader();
        reader.onloadend = () => {
          setProfileView(reader.result);
        };
        reader.readAsDataURL(file);
    }

    return (
        <div className="w-full max-w-2xl  bg-white rounded-3xl border shadow-md lg:max-w-4xl lg:p-4 lg:mx-2">
         <form onSubmit={formik.handleSubmit} className="flex flex-col">      
        
        <label htmlFor="profile_picture" className=" max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Profile Picture</label>
        <input
          id="profile_picture"
          name="profile_picture"
          type="file"
          accept="image/*" 
          onChange={handleFileChange}
          className=" max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center" 
        />        

        {profileView && (
          <img src={profileView} alt="Profile Preview" className=" w-32 h-32 rounded-lg" />
        )}
         <label htmlFor="username" className="max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Username</label>
         <input
          id="username"
          name="username"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.username}
          placeholder="Enter the username"
          className=" max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center "
        />
        {formik.touched.username && formik.errors.username ? <p className="text-red-500 italic">{formik.errors.username}</p> : null}

        <label htmlFor="email" className="max-w-full min-w-fit rounded-lg font-bold">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
           className="max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.email && formik.errors.email ? <p className="text-red-500 italic">{formik.errors.email}</p> : null}

        <label htmlFor="password" className="max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Password</label>
        <input
          id="password"
          name="password"
          type="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
                   className="max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.password && formik.errors.password ? <p className="text-red-500 italic">{formik.errors.password}</p> : null}

        <label htmlFor="confirm_password" className="max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Confirm Password</label>
        <input
          id="confirm_password"
          name="confirm_password"
          type="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.confirm_password}
                    className="max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.confirm_password && formik.errors.confirm_password ? <p className="text-red-500 italic">{formik.errors.confirm_password}</p> : null}

        <label htmlFor="name" className="max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Name</label>
        <input
          id="name"
          name="name"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.name}
          placeholder="Enter your name"
                    className="max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.name && formik.errors.name ? <p className="text-red-500 italic">{formik.errors.name}</p> : null}
        
        <button
          type="submit"
          className="disabled:opacity-50 bg-blue-500 rounded-full mt-6 h-12"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          Register
        </button>
        {errorMessage && <p className="text-red-500 mt-10">{errorMessage}</p>}
      </form>
      <p>Already have an account? <a href="/loginUser" className="text-blue-500 flex mb-12">Login</a></p>
        </div>
    )
}